import React from "react";
import "./GlowCta.scss";
import { Link } from "react-router-dom";
import { rightarrowwhite } from "../../images";
import { useWindowSize } from "react-use";

const GlowCta = ({ link, text }) => {
  const { width } = useWindowSize();
  const isExternal = link?.startsWith("http");
  const Wrapper = isExternal ? "a" : Link;
  const linkProps = isExternal ? { href: link } : { to: link };
  return (
    <>
      <div className="glowcta_wrapper">
        <Wrapper {...linkProps} className="cta_link">
          <p className="cta_text">
            <span dangerouslySetInnerHTML={{ __html: text }}></span>
            {width < 600 && (
              <img src={rightarrowwhite} alt="arrow" className="arrow_img" />
            )}
          </p>
          {width > 600 && (
            <img src={rightarrowwhite} alt="arrow" className="arrow_img" />
          )}
        </Wrapper>
      </div>
    </>
  );
};

export default GlowCta;
